module.exports = __webpack_public_path__ + "img/21.62c177b4.png";